import { render } from "./MBadgeCard.vue?vue&type=template&id=dcc78856"
import script from "./MBadgeCard.vue?vue&type=script&lang=ts"
export * from "./MBadgeCard.vue?vue&type=script&lang=ts"
script.render = render

export default script